import datacentral from '@/utils/axios/datacentral'
import queryString from 'query-string'
import { DataGridPayload } from 'vnetwork-ui/dist/components/GokuDataGrid'
import { ResponseArray, ResponseObject } from '@/types/shared'
import { ServiceUsageTemplateAPI } from '../types'

export const getServiceUsageTemplateAPIs = async (
    payload: DataGridPayload
): Promise<ResponseArray<ServiceUsageTemplateAPI>> => {
    const response = await datacentral.get<
        ResponseArray<ServiceUsageTemplateAPI>
    >(`service-usage-template-apis?${queryString.stringify(payload)}`)
    return response?.data
}

export const getServiceUsageTemplateAPIById = async (
    id: number
): Promise<ResponseObject<ServiceUsageTemplateAPI>> => {
    const response = await datacentral.get<
        ResponseObject<ServiceUsageTemplateAPI>
    >(`service-usage-template-apis/${id}`)
    return response?.data
}

export const createServiceUsageTemplateAPI = async (
    data: any
): Promise<ResponseObject<ServiceUsageTemplateAPI>> => {
    const response = await datacentral.post(`service-usage-template-apis`, data)
    return response?.data
}

export const updateServiceUsageTemplateAPI = async (
    id: number,
    data: any
): Promise<ResponseObject<ServiceUsageTemplateAPI>> => {
    const response = await datacentral.put(
        `service-usage-template-apis/${id}`,
        data
    )
    return response?.data
}

export const deleteServiceUsageTemplateAPI = async (
    id: number
): Promise<void> => {
    const response = await datacentral.delete(
        `service-usage-template-apis/${id}`
    )
    return response?.data
}

export const getServiceUsageTemplateAPIsByTemplateId = async (
    templateId: string
): Promise<ResponseArray<ServiceUsageTemplateAPI>> => {
    const response = await datacentral.get<
        ResponseArray<ServiceUsageTemplateAPI>
    >(`service-usage-template-apis/template/${templateId}`)
    return response?.data
}

export const testServiceUsageTemplateAPI = async (data: any): Promise<any> => {
    const response = await datacentral.post(
        `service-usage-template-apis/test`,
        data
    )
    return response?.data
}
